import React, { useState, useEffect } from 'react';
import Axios from '../../Components/Axios/Axios';
import Auth from '../../Components/Auth/Auth';
import { useHistory } from 'react-router-dom';
import { USER_KEY } from '../../Constants/index';
import { Button, Grid, Paper, TextField } from '@mui/material';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import FadeLoader from "react-spinners/FadeLoader";
import dateFormat from 'dateformat';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';

function ServiceHistory({ refresh }) {
    // For History
    const history = useHistory();

    // Set Loading
    const [loading, setLoading] = useState(false);

    // For Set Style Paper
    const paperStyle = { padding: 20, width: 'auto' }

    // Set data for thoundsand number format
    const USformatter = new Intl.NumberFormat("en-US");

    // For get Data Service History
    const [dataServHistory, setDataServHistory] = useState([]);
    const [dataAllService, setDataAllService] = useState("");

    // For get data from user login
    const tokenData = JSON.parse(localStorage.getItem(USER_KEY));
    const token = tokenData.token;
    const _empID = tokenData.emp_info[0].emp_id;
    const _empCode = tokenData.emp_info[0].emp_code;
    const _empName = tokenData.emp_info[0].fNameLao + " " + tokenData.emp_info[0].lNameLao;
    const _empGender = tokenData.emp_info[0].emp_gender;

    let _empGen;
    if (_empGender == 'F') {
        _empGen = "ທ່ານນາງ"
    } else {
        _empGen = "ທ່ານ"
    }
    const _empFull = _empGen + " " + _empName;

    // For Start Date Search
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    // For Loading Data
    const loadData = async () => {
        setLoading(true)

        setTimeout(() => {
            setLoading(false)
        }, 500);
    }

    useEffect(() => {
        loadData()
    }, [refresh])

    // Sum Total Qty
    let totalQty = 0;
    if (dataServHistory.length > 0) {
        let cycle = dataServHistory.length;
        for (let i = 0; i < cycle; i++) {
            let _qty = dataServHistory[i].service_qty;
            totalQty = totalQty + _qty;
        }
    }

    // Sum Total Price
    let totalPrice = 0;
    if (dataServHistory.length > 0) {
        let cycle = dataServHistory.length;
        for (let i = 0; i < cycle; i++) {
            let _price = dataServHistory[i].service_price;
            totalPrice = totalPrice + _price;
        }
    }

    // Function for Search Button
    const searchServHistory = async () => {
        if (startDate.length != 0 && endDate.length != 0) {
            if (startDate <= endDate) {
                try {
                    // Set Start and End Date Data
                    let dateData = {
                        "start_date": startDate,
                        "end_date": endDate,
                        "employee_id": _empID
                    }

                    await Axios.post("Report/Staff/Service/History", dateData, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                        // Check token Expired
                        if (res.data.result_code == '403') {
                            Auth.logout(() => {
                                history.push("/");
                            });
                        }

                        if (res.data.result_code == "200") {
                            setDataServHistory(res.data.service_info);
                            setDataAllService(res.data.all_service);
                        } else {
                            setDataServHistory([])
                            setDataAllService("")
                        }
                    })
                } catch (error) {
                    // console.log(error)
                }
            }
        }
    }

    // Function for Export Excel Button
    const exportHistory = async () => {
        var wb = XLSX.utils.book_new(),
            ws = XLSX.utils.json_to_sheet(dataServHistory);

        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        XLSX.writeFile(wb, "CS_Report.xlsx");
    }

    return (
        <>
            {loading ? <>
                <div className='manage_loading'>
                    <FadeLoader color={'#ED1C24'} loading={loading} size={10} />
                </div>
            </> : <>
                <div className='manage_title'>ປະຫວັດການບໍລິການ</div>

                <Paper elevation={10} style={paperStyle} className='manage_paper'>
                    <Grid container>
                        <Grid item xs={2}>
                            <Grid item xs={10} style={{ marginBottom: 10 }}>
                                <span className='manage_input_label'>ລະຫັດພະນັກງານ:</span>
                            </Grid>

                            <Grid item xs={10}>
                                <TextField
                                    autoComplete='off'
                                    className='form-control mt-1'
                                    id="input-with-icon-textfield"
                                    size='small'
                                    variant='outlined'
                                    fullWidth
                                    value={_empCode}
                                    disabled
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={4}>
                            <Grid item xs={11} style={{ marginBottom: 10 }}>
                                <span className='manage_input_label'>ຊື່ ແລະ ນາມສະກຸນ:</span>
                            </Grid>

                            <Grid item xs={11}>
                                <TextField
                                    autoComplete='off'
                                    className='form-control mt-1'
                                    id="input-with-icon-textfield"
                                    size='small'
                                    variant='outlined'
                                    fullWidth
                                    value={_empFull}
                                    disabled
                                />
                            </Grid>
                        </Grid>


                        <Grid item xs={2}>
                            <Grid item xs={10} style={{ marginBottom: 10 }}>
                                <span className='manage_input_label'>ເລີ່ມວັນທີ:</span>
                            </Grid>

                            <Grid item xs={10}>
                                <TextField
                                    autoComplete='off'
                                    className='form-control mt-1'
                                    id="input-with-icon-textfield"
                                    size='small'
                                    variant='outlined'
                                    fullWidth
                                    type='date'
                                    onChange={(e) => { setStartDate(e.target.value) }}
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={2}>
                            <Grid item xs={10} style={{ marginBottom: 10 }}>
                                <span className='manage_input_label'>ຫາວັນທີ:</span>
                            </Grid>

                            <Grid item xs={10}>
                                <TextField
                                    autoComplete='off'
                                    className='form-control mt-1'
                                    id="input-with-icon-textfield"
                                    size='small'
                                    variant='outlined'
                                    fullWidth
                                    type='date'
                                    onChange={(e) => { setEndDate(e.target.value) }}
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={2}>
                            <Grid item xs={12} style={{ marginTop: 33 }}>
                                <Button className="manage_search_button" fullWidth variant="outlined" onClick={searchServHistory}><SearchIcon />ເບິ່ງຂໍ້ມູນ</Button>
                            </Grid>
                        </Grid>

                    </Grid>
                </Paper>

                {dataServHistory && dataServHistory.length > 0 ? <>
                    <Paper elevation={10} style={paperStyle} className='manage_paper'>
                        <Grid container>
                            <Grid item xs={10}>
                                <div className='manage_title'>ລາຍລະອຽດການບໍລິການ (ລວມທັງໝົດ: <span className='manage_count_service'>{USformatter.format(dataAllService)}</span> ລາຍການ)</div>
                            </Grid>

                            <Grid item xs={2}>
                                <Button className="manage_export_button" fullWidth variant="outlined" onClick={exportHistory}>Export Excel</Button>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} style={{ marginTop: 20 }}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='manage_table_header' align='center'><span className='manage_table_headtext'>ລໍາດັບ</span></TableCell>
                                            <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ປ່ອງບໍລິການ</span></TableCell>
                                            <TableCell className='manage_table_header' align='center'><span className='manage_table_headtext'>ວັນທີ</span></TableCell>
                                            <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ຊື່ລູກຄ້າ</span></TableCell>
                                            <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ເບີໂທລະສັບ</span></TableCell>
                                            <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ບໍລິການ</span></TableCell>
                                            <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ລາຍລະອຽດ</span></TableCell>
                                            <TableCell className='manage_table_header' align='right'><span className='manage_table_headtext'>ຈໍານວນບໍລິການ</span></TableCell>
                                            <TableCell className='manage_table_header' align='right'><span className='manage_table_headtext'>ລວມຄ່າບໍລິການ (ກີບ)</span></TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {dataServHistory && dataServHistory.length > 0 ?
                                            <>
                                                {dataServHistory.map((row, idx) => (
                                                    <TableRow key={idx}>
                                                        <TableCell align='center'><span className='manage_table_data'>{idx + 1}</span></TableCell>
                                                        <TableCell align='left'><span className='manage_table_data'>{row.counter_name}</span></TableCell>
                                                        <TableCell align='center'>
                                                            <span className='manage_table_data'>
                                                                {dateFormat(row.queue_date, "dd/mm/yyyy HH:MM:ss")}
                                                            </span>
                                                        </TableCell>
                                                        <TableCell align='left'><span className='manage_table_data'>{row.cus_name}</span></TableCell>
                                                        <TableCell align='left'><span className='manage_table_data'>{row.cus_tel}</span></TableCell>
                                                        <TableCell align='left'><span className='manage_table_data'>{row.service_name}</span></TableCell>
                                                        <TableCell align='left'><span className='manage_table_data'>{row.description}</span></TableCell>
                                                        <TableCell align='right'>
                                                            <span className='manage_table_data'>
                                                                {USformatter.format(row.service_qty)}
                                                            </span>
                                                        </TableCell>
                                                        <TableCell align='right'>
                                                            <span className='manage_table_data'>
                                                                {USformatter.format(row.service_price)}
                                                            </span>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </> : <>
                                                <TableBody>
                                                    <TableCell style={{ justifyContent: "center", alignItems: 'center' }}>No Data...</TableCell>
                                                </TableBody>
                                            </>}
                                    </TableBody>

                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={7} className='manage_table_header' align='right'><span className='manage_table_headtext'>ລວມທັງໝົດ:</span></TableCell>
                                            <TableCell colSpan={1} className='manage_table_header' align='right'>
                                                <span className='manage_table_headtext'>
                                                    {USformatter.format(totalQty)} (ບໍລິການ)
                                                </span>
                                            </TableCell>
                                            <TableCell colSpan={1} className='manage_table_header' align='right'>
                                                <span className='manage_table_headtext'>
                                                    {USformatter.format(totalPrice)} (ກີບ)
                                                </span>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Paper>
                </> : <></>}
            </>}
        </>
    )
}

export default ServiceHistory